unit ProcessScreenType;

interface

uses
  DeviceListType, NetNumberStatusListType, NetStatusListType, TemperatureListType, TypeListType;

type
  TProcessScreenType = class
  private
    fNetStatusList: TNetStatusListType;
    fDeviceList: TDeviceListType;
    fTemperatureList: TTemperatureListType;
    fNetNumberStatusList: TNetNumberStatusListType;
  public
    property NetStatusList: TNetStatusListType read fNetStatusList;
    property DeviceList: TDeviceListType read fDeviceList;
    property TemperatureList: TTemperatureListType read fTemperatureList;
    property NetNumberStatusList: TNetNumberStatusListType read fNetNumberStatusList;
  end;

implementation

end.
